import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    company: [],
    paymentForm: {
      company: null,
      taxNo: null,
      taxOffice: null,
      phone: null,
      address: null,
      nameSurname: null,
      content: null,
      cardNumber: '',
      expirationDate: null,
      cvv: null,
      amount: null,
      pay_amount: null,
      cardType: null,
      bank: null,
      bank_logo: null,
      installment: '0',
      id_pos_configs: null,
      id_customers: null,
      selectInstallment: null,
    },
    installments: [],
    paymentSendForm: {
      pay3d: null,
      action: null,
      elements: {},
      error: null,
      result: {
        approved: null,
      },
      modal: false,
    },
  },
  getters: {
    getPaymentForm(state) {
      return state.paymentForm
    },
    getCompany(state) {
      return state.company
    },
    getInstallments(state) {
      return state.installments
    },
    getPaymentSendForm(state) {
      return state.paymentSendForm
    },
  },
  mutations: {
    PAYMENT_SEND(state, data) {
      state.paymentSendForm = data
    },
    PAYMENT_RESULT_UPDATE(state, data) {
      state.paymentSendForm.result.approved = data.approved
      if (data.error) state.paymentSendForm.error = data.error
    },
    CARD_TYPE(state, data) {
      state.paymentForm.cardType = data
    },
    BANK(state, data) {
      state.paymentForm.bank = data
    },
    BANK_LOGO(state, data) {
      state.paymentForm.bank_logo = data
    },
    ID_POS_CONFIGS(state, data) {
      state.paymentForm.id_pos_configs = data
    },
    SELECT_INSTALLMENT(state, data) {
      state.paymentForm.selectInstallment = data
    },
    INSTALLMENTS(state, data) {
      state.installments = data
    },
    SET_COMPANY(state, data) {
      state.company = data
    },
    RESET_FORM(state) {
      state.paymentForm = {
        company: null,
        taxNo: null,
        taxOffice: null,
        phone: null,
        address: null,
        nameSurname: null,
        content: null,
        cardNumber: '',
        expirationDate: null,
        cvv: null,
        amount: null,
        pay_amount: null,
        cardType: null,
        bank: null,
        bank_logo: null,
        installment: '0',
        id_pos_configs: null,
        id_customers: null,
        selectInstallment: null,
      }
    },
    RESET_COMPANY(state) {
      state.company = []
    },
  },
  actions: {
    paymentSend({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post('/payments', data)
        .then(response => {
          commit('PAYMENT_SEND', response.data.data)
        })
        .catch(error => console.error(error))
    },
    setCompany({ commit }, postData) {
      const data = JSON.stringify(postData)
      return axiosIns
        .post('/payments/getCompany', data)
        .then(response => {
          commit('SET_COMPANY', response.data.data)
          return response.data.data
        })
        .catch(error => console.error(error))
    },
    getCardType({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post('/bins', data)
        .then(response => {
          commit('CARD_TYPE', response.data.card_organization)
          commit('BANK', response.data.bank)
          commit('BANK_LOGO', response.data.bank_logo)
          if (!response.data.pos) return
          if (response.data.pos.id_pos_configs) {
            commit('ID_POS_CONFIGS', response.data.pos.id_pos_configs)
          }
          if (response.data.pos.installments) {
            commit('INSTALLMENTS', response.data.pos.installments)
          }
          if (response.data.pos.selectInstallment) {
            commit('SELECT_INSTALLMENT', String(response.data.pos.selectInstallment))
          }
        })
        .catch(error => console.error(error))
    },
    resetForm({ commit }) {
      commit('RESET_FORM')
    },
  },
}
